import { ArrowDropDown } from '@mui/icons-material';
import { Button } from 'components/ui/Button';
import { Skeleton } from 'components/ui/Skeleton';
import type {
  DialogActionFooterProps,
  DialogSelectTriggerContentProps,
} from './Dialog.props';
import {
  DialogActions,
  DialogSelectTriggerIcon,
  DialogSelectTriggerValue,
} from './Dialog.styles';

const getSelectTriggerValue = ({
  isLoading = false,
  loadingWidth = 160,
  placeholder,
  value,
}: DialogSelectTriggerContentProps) => {
  if (value !== undefined && value !== null) {
    return value;
  }

  if (isLoading) {
    return <Skeleton height={14} radius={4} width={loadingWidth} />;
  }

  return placeholder;
};

export const DialogSelectTriggerContent = ({
  showDropdownIcon = true,
  ...props
}: DialogSelectTriggerContentProps) => (
  <>
    <DialogSelectTriggerValue>{getSelectTriggerValue(props)}</DialogSelectTriggerValue>
    {showDropdownIcon ? (
      <DialogSelectTriggerIcon>
        <ArrowDropDown />
      </DialogSelectTriggerIcon>
    ) : null}
  </>
);

export const DialogActionFooter = ({
  actionButtonTestId,
  actionLabel,
  actionVisualVariant = 'brand',
  cancelButtonTestId,
  cancelLabel = 'Cancel',
  cancelVisualVariant = 'brandOutline',
  isActionDisabled = false,
  isActionLoading = false,
  isCancelDisabled = false,
  onAction,
  onCancel,
}: DialogActionFooterProps) => (
  <DialogActions>
    <Button
      data-testid={cancelButtonTestId}
      disabled={isCancelDisabled}
      onClick={onCancel}
      visualVariant={cancelVisualVariant}>
      {cancelLabel}
    </Button>
    <Button
      data-testid={actionButtonTestId}
      disabled={isActionDisabled}
      loading={isActionLoading}
      onClick={onAction}
      visualVariant={actionVisualVariant}>
      {actionLabel}
    </Button>
  </DialogActions>
);

export {
  DialogActions,
  DialogCloseButton,
  DialogCloseIcon,
  DialogContent,
  DialogDescription,
  DialogEmphasis,
  DialogHeader,
  DialogRoot as default,
  DialogSelectTrigger,
  DialogSelectTriggerIcon,
  DialogSelectTriggerValue,
  DialogTitle,
  DialogWarning,
  DialogWarningIcon,
} from './Dialog.styles';
